import { render, staticRenderFns } from "./DevCardKA1.vue?vue&type=template&id=1abb3555&scoped=true"
import script from "./DevCardKA1.vue?vue&type=script&lang=js"
export * from "./DevCardKA1.vue?vue&type=script&lang=js"
import style0 from "./DevCardKA1.vue?vue&type=style&index=0&id=1abb3555&prod&lang=css"
import style1 from "./DevCardKA1.vue?vue&type=style&index=1&id=1abb3555&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb3555",
  null
  
)

export default component.exports